import React, {Component, ReactElement, ReactNode} from 'react'
import EventEmitterExAdmin from '../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import {AdminPagePropsSet, createAdminPage} from '../../../components/shared/hoc/createAdminPage'
import {Nullable} from '../../../app/TypeHelpers'
import {PageFooterArea, PageFotterAreaLeft, PageMainArea} from '../../../components/shared/hoc/withAdminPageTemplate'
import {AdminPrimaryButton} from '../../../styledComponents/adminPage/Buttons'
import {BackLink} from '../../../styledComponents/adminPage/Links'
import {Box, Table, TableBody, TableCell, TableRow} from '@mui/material'
import NatFacilityRepo from '../facility/repository/NatFacilityRepo'
import {FacilityIntroductoryInfo, NatGetFacilityIntroductory} from './repository/NatGetFacilityIntroductory'
import {HeadingAreaMessageParams} from '../../../components/shared/pageBaseComponents/HeadingAreaMessageComponent'
import {StyledTableCaption, TableRowName} from '../../../styledComponents/adminPage/Table'
import {HKConstants} from '../../../HKConstants'
import AuthorityChecker from '../../../components/AuthorityChecker'
import {Location} from 'react-router-dom'

interface LocationState {
    initialMessage: HeadingAreaMessageParams
}

interface Props {
    condominiumCd: string
    facilityId: string
    facilityRepo: NatFacilityRepo
    eventEmitter: EventEmitterExAdmin
    location: Location<LocationState>
}

interface States {
    facilityIntroductoryInfo: FacilityIntroductoryInfo
    isLoadCompleted: boolean
}


class NatAdminFacilityIntroductoryPage extends Component<Props & AdminPagePropsSet, States> {

    constructor(props: Props & AdminPagePropsSet) {
        super(props)

        this.state = {
            facilityIntroductoryInfo: {
                facilityId: '',
                facilityName: '',
                facilityIntroductory: '',
                version: 0,
            },
            isLoadCompleted: false,
        }
        this.backFacilityLinkClick = this.backFacilityLinkClick.bind(this)
        this.editFacilityIntroductoryLinkClick = this.editFacilityIntroductoryLinkClick.bind(this)
    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            // 施設紹介文取得
            const facilityIntroductoryResponse: Nullable<NatGetFacilityIntroductory> =
                await this.props.asyncCallFunction(
                    this.props.facilityRepo.getFacilityIntroductory.bind(
                        this.props.facilityRepo, this.props.facilityId),
                    (httpErrorOrNetworkError) => {
                        this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                    },
                )
            if (facilityIntroductoryResponse && facilityIntroductoryResponse.details) {
                this.setState({facilityIntroductoryInfo: facilityIntroductoryResponse.details})
            }


            this.showInitialMessage()
        } finally {
            this.props.eventEmitter.closeLoading()
            this.setState({isLoadCompleted: true})
        }
    }

    showInitialMessage(): void {
        if (!this.props.location || !this.props.location.state) {
            return
        }
        const initialMessage: HeadingAreaMessageParams = this.props.location.state.initialMessage
        this.props.navigate(this.props.location.pathname, {replace: true})
        this.props.eventEmitter.showHeadingAreaMessage(initialMessage)
        this.props.eventEmitter.closeLoading()
    }

    backFacilityLinkClick(): void {
        this.props.navigate(`/admin/condominiums/${this.props.condominiumCd}/facilities/search`)
    }

    editFacilityIntroductoryLinkClick(): void {
        this.props.navigate(
            `/admin/condominiums/${this.props.condominiumCd}/facilities/${this.props.facilityId}/introductoryEdit`,
            {
                state: {
                    previousPageUrl: this.props.location.pathname,
                    previousPageName: '施設紹介文詳細',
                },
            },
        )
    }

    renderPageHeaderArea(): Nullable<ReactNode> {
        return (
            <>

                <PageFotterAreaLeft>
                    <AdminPrimaryButton
                        onClick={this.editFacilityIntroductoryLinkClick}>
                        紹介文編集
                    </AdminPrimaryButton>
                </PageFotterAreaLeft>

            </>
        )
    }

    renderPageFooterArea(): ReactNode {
        return (
            <>
                <PageFotterAreaLeft>
                    <BackLink
                        onClick={this.backFacilityLinkClick}
                    >
                        施設検索へ戻る
                    </BackLink>
                </PageFotterAreaLeft>
            </>
        )
    }


    renderDetailsTable(): ReactElement {
        return (
            <>
                <Table>
                    <StyledTableCaption>施設情報</StyledTableCaption>
                    <TableBody>
                        <TableRow>
                            <TableRowName>施設名</TableRowName>
                            <TableCell>
                                {this.state.facilityIntroductoryInfo.facilityName}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>施設紹介文</TableRowName>
                            <TableCell>
                                <div dangerouslySetInnerHTML=
                                         {{__html: this.state.facilityIntroductoryInfo.facilityIntroductory || ''}}/>
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </>
        )
    }


    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }
        return (
            <>
                <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.EDIT_FACILITY_DESCRIPTION}>
                    <Box mb={'15px'}>
                        <PageFooterArea>
                            {this.renderPageHeaderArea()}
                        </PageFooterArea>
                    </Box>
                </AuthorityChecker>
                <PageMainArea>
                    {this.renderDetailsTable()}
                </PageMainArea>
                <PageFooterArea>
                    {this.renderPageFooterArea()}
                </PageFooterArea>
            </>
        )
    }
}

export default createAdminPage(NatAdminFacilityIntroductoryPage)

